import { User } from '@lumapps/user/types';

import { NotificationGroup, Notification } from '../types';

const mapNotificationGroupToProps = (
    group: NotificationGroup,
): { notification: Notification; senderDetails: User | null } => {
    const firstActions = group.actions && group.actions[0] ? group.actions[0] : null;

    return {
        notification: group.notification,
        senderDetails: firstActions ? firstActions.senderDetails : null,
    };
};

export { mapNotificationGroupToProps };
